import { render, staticRenderFns } from "./modalCambiarImagen.vue?vue&type=template&id=06e12359"
import script from "./modalCambiarImagen.vue?vue&type=script&lang=js"
export * from "./modalCambiarImagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports